// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.quiz-results {
  max-width: 900px;
  margin: 0 auto;
}

.quiz-results h1 {
  margin-bottom: 2rem;
  color: #2c3e50;
}

.results-summary {
  background: white;
  border-radius: 8px;
  padding: 2rem;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  display: flex;
  gap: 2rem;
  align-items: center;
  margin-bottom: 2rem;
}

.results-summary.passed {
  border-left: 8px solid #27ae60;
}

.results-summary.failed {
  border-left: 8px solid #e74c3c;
}

.score-circle {
  text-align: center;
  padding: 2rem;
}

.score-value {
  font-size: 4rem;
  font-weight: bold;
  line-height: 1;
}

.results-summary.passed .score-value {
  color: #27ae60;
}

.results-summary.failed .score-value {
  color: #e74c3c;
}

.score-label {
  font-size: 1.5rem;
  font-weight: bold;
  margin-top: 0.5rem;
}

.results-details {
  flex: 1 1;
}

.results-details p {
  margin: 0.5rem 0;
  color: #2c3e50;
}

.questions-review {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.review-question {
  padding: 1.5rem;
  border-radius: 8px;
  border: 2px solid;
}

.review-question.correct {
  background: #d4edda;
  border-color: #27ae60;
}

.review-question.incorrect {
  background: #f8d7da;
  border-color: #e74c3c;
}

.review-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.result-badge {
  padding: 0.25rem 0.75rem;
  border-radius: 4px;
  font-weight: 600;
  font-size: 0.875rem;
}

.result-badge.correct {
  background: #27ae60;
  color: white;
}

.result-badge.incorrect {
  background: #e74c3c;
  color: white;
}

.answer-review {
  margin-top: 1rem;
}

.options-review {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.option-review {
  padding: 0.75rem;
  border-radius: 4px;
  background: white;
}

.option-review.correct-answer {
  background: #d4edda;
  border: 2px solid #27ae60;
  font-weight: 600;
}

.option-review.wrong-answer {
  background: #f8d7da;
  border: 2px solid #e74c3c;
}

.indicator {
  font-weight: 600;
  margin-right: 0.5rem;
}

.results-actions {
  display: flex;
  gap: 1rem;
  justify-content: center;
  margin-top: 2rem;
}
`, "",{"version":3,"sources":["webpack://./src/pages/student/QuizResults.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,qCAAqC;EACrC,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,gBAAgB;AAClB","sourcesContent":[".quiz-results {\r\n  max-width: 900px;\r\n  margin: 0 auto;\r\n}\r\n\r\n.quiz-results h1 {\r\n  margin-bottom: 2rem;\r\n  color: #2c3e50;\r\n}\r\n\r\n.results-summary {\r\n  background: white;\r\n  border-radius: 8px;\r\n  padding: 2rem;\r\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\r\n  display: flex;\r\n  gap: 2rem;\r\n  align-items: center;\r\n  margin-bottom: 2rem;\r\n}\r\n\r\n.results-summary.passed {\r\n  border-left: 8px solid #27ae60;\r\n}\r\n\r\n.results-summary.failed {\r\n  border-left: 8px solid #e74c3c;\r\n}\r\n\r\n.score-circle {\r\n  text-align: center;\r\n  padding: 2rem;\r\n}\r\n\r\n.score-value {\r\n  font-size: 4rem;\r\n  font-weight: bold;\r\n  line-height: 1;\r\n}\r\n\r\n.results-summary.passed .score-value {\r\n  color: #27ae60;\r\n}\r\n\r\n.results-summary.failed .score-value {\r\n  color: #e74c3c;\r\n}\r\n\r\n.score-label {\r\n  font-size: 1.5rem;\r\n  font-weight: bold;\r\n  margin-top: 0.5rem;\r\n}\r\n\r\n.results-details {\r\n  flex: 1;\r\n}\r\n\r\n.results-details p {\r\n  margin: 0.5rem 0;\r\n  color: #2c3e50;\r\n}\r\n\r\n.questions-review {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 1.5rem;\r\n}\r\n\r\n.review-question {\r\n  padding: 1.5rem;\r\n  border-radius: 8px;\r\n  border: 2px solid;\r\n}\r\n\r\n.review-question.correct {\r\n  background: #d4edda;\r\n  border-color: #27ae60;\r\n}\r\n\r\n.review-question.incorrect {\r\n  background: #f8d7da;\r\n  border-color: #e74c3c;\r\n}\r\n\r\n.review-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.result-badge {\r\n  padding: 0.25rem 0.75rem;\r\n  border-radius: 4px;\r\n  font-weight: 600;\r\n  font-size: 0.875rem;\r\n}\r\n\r\n.result-badge.correct {\r\n  background: #27ae60;\r\n  color: white;\r\n}\r\n\r\n.result-badge.incorrect {\r\n  background: #e74c3c;\r\n  color: white;\r\n}\r\n\r\n.answer-review {\r\n  margin-top: 1rem;\r\n}\r\n\r\n.options-review {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.5rem;\r\n}\r\n\r\n.option-review {\r\n  padding: 0.75rem;\r\n  border-radius: 4px;\r\n  background: white;\r\n}\r\n\r\n.option-review.correct-answer {\r\n  background: #d4edda;\r\n  border: 2px solid #27ae60;\r\n  font-weight: 600;\r\n}\r\n\r\n.option-review.wrong-answer {\r\n  background: #f8d7da;\r\n  border: 2px solid #e74c3c;\r\n}\r\n\r\n.indicator {\r\n  font-weight: 600;\r\n  margin-right: 0.5rem;\r\n}\r\n\r\n.results-actions {\r\n  display: flex;\r\n  gap: 1rem;\r\n  justify-content: center;\r\n  margin-top: 2rem;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
